import config from '../config';

export const customLinkCreationPath = `${config.pathPrefix}create-checkout/`;
export const PAGES = {
  Descriptions: `${customLinkCreationPath}descriptions`,
  CustomAmounts: `${customLinkCreationPath}custom-amounts`,
  Frequency: `${customLinkCreationPath}frequency`,
  LinkDetails: `${customLinkCreationPath}link-details`,
  PostDonationDetails: `${customLinkCreationPath}post-donation-details`,
  LinkLibrary: `${config.pathPrefix}link-library`,
};

export type PageName = keyof typeof PAGES;
